export const parseNoticeText = (noticeText) => {
  if (!noticeText) return { title: 'Notice', body: '' };

  if (noticeText.startsWith('**')) {
    const endBold = noticeText.indexOf('**', 2);
    if (endBold > 2) {
      return {
        title: noticeText.substring(2, endBold),
        body: noticeText.substring(endBold + 2).replace(/^\n\n/, ''),
      };
    }
  }

  return { title: 'Notice', body: noticeText };
};

export const normalizeNotice = (notice) => {
  const parsed = parseNoticeText(notice.notice || notice.content || '');
  const createdAt = notice.created_at ? new Date(notice.created_at) : null;
  const ageHours = createdAt ? (Date.now() - createdAt.getTime()) / 36e5 : Infinity;

  return {
    ...notice,
    title: notice.title || parsed.title,
    body: notice.body || parsed.body,
    authorName: notice.first_name ? `${notice.first_name} ${notice.last_name || ''}`.trim() : 'Admin',
    createdAt,
    isNew: ageHours <= 24,
  };
};

export const formatNoticeTime = (date) => {
  if (!date) return 'Unknown time';

  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
};
